import _assign from "object-assign";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { memo, forwardRef, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDensity, withStyles } from '@jpmuitk/theme';
import { useOverflowDetection } from '@jpmuitk/utils';
import { useForkRef } from '@material-ui/core/utils';
import { CheckboxBase } from '@jpmuitk/checkbox';
import { useTooltipContext } from './TooltipContext';
import Highlighter from './Highlighter';
var densityToTypeSizePaletteIndex = {
  touch: 70,
  low: 60,
  medium: 50,
  high: 40
};
export var styles = function styles(theme) {
  var _theme$toolkit = theme.toolkit,
      _theme$toolkit$select = _theme$toolkit.selectable,
      getSelectable = _theme$toolkit$select.getSelectable,
      selectableStates = _theme$toolkit$select.selectableStates,
      getFocusable = _theme$toolkit.focusable.getFocusable,
      getDisabled = _theme$toolkit.disabled.getDisabled,
      white = _theme$toolkit.palette.white,
      spacing = _theme$toolkit.spacing,
      typography = _theme$toolkit.typography;
  var defaultSelectableStyle = getSelectable(selectableStates["default"]);

  var createDensityStyle = function createDensityStyle(density) {
    var spacingMixin = spacing[density].spacing;
    var lineHeight = typography.lineHeight,
        fontSize = typography.size;
    return _defineProperty({
      lineHeight: lineHeight,
      fontSize: fontSize[densityToTypeSizePaletteIndex[density]],
      padding: spacingMixin(0, 1, 0, 1)
    }, '& $checkbox', {
      marginRight: spacingMixin(1)
    });
  };

  return {
    root: _assign({
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      left: 0,
      right: 0,
      boxSizing: 'border-box',
      cursor: 'pointer'
    }, defaultSelectableStyle, {
      '&:not(:last-of-type)': {
        borderBottom: "1px solid ".concat(defaultSelectableStyle.background)
      },
      '&$highlighted:not($selected)': getSelectable(selectableStates.active)
    }),
    checkbox: {
      alignSelf: 'center'
    },
    textWrapper: {
      flex: 1,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    textHighlight: {},
    highlighted: {},
    quickSelected: {
      background: getSelectable(selectableStates.active).background
    },
    selected: getSelectable(selectableStates.selected),
    disabled: getDisabled(),
    focusVisible: {
      '&:after': _assign({
        content: '""',
        position: 'absolute',
        top: 2,
        right: 2,
        bottom: 2,
        left: 2
      }, getFocusable()),
      '&$selected': {
        '&:after': {
          outlineColor: white
        }
      }
    },
    touchDensity: createDensityStyle('touch'),
    lowDensity: createDensityStyle('low'),
    mediumDensity: createDensityStyle('medium'),
    highDensity: createDensityStyle('high')
  };
};
var ListItemBase = /*#__PURE__*/forwardRef(function ListItemBase(props, ref) {
  var classes = props.classes,
      className = props.className,
      selected = props.selected,
      highlighted = props.highlighted,
      focusVisible = props.focusVisible,
      tooltipText = props.tooltipText,
      disabled = props.disabled,
      children = props.children,
      itemTextHighlightPattern = props.itemTextHighlightPattern,
      densityProp = props.density,
      checkable = props.checkable,
      quickSelected = props.quickSelected,
      restProps = _objectWithoutProperties(props, ["classes", "className", "selected", "highlighted", "focusVisible", "tooltipText", "disabled", "children", "itemTextHighlightPattern", "density", "checkable", "quickSelected"]);

  var density = useDensity(densityProp);

  var _useState = useState(false),
      openTooltip = _useState[0],
      setOpenTooltip = _useState[1];

  var _useTooltipContext = useTooltipContext(),
      Tooltip = _useTooltipContext.Tooltip,
      enterDelay = _useTooltipContext.enterDelay,
      leaveDelay = _useTooltipContext.leaveDelay,
      placement = _useTooltipContext.placement;

  var _useRef = useRef(typeof children === 'string'),
      detectTruncation = _useRef.current;

  var _useOverflowDetection = useOverflowDetection(),
      _useOverflowDetection2 = _slicedToArray(_useOverflowDetection, 2),
      overflowRef = _useOverflowDetection2[0],
      isOverflowed = _useOverflowDetection2[1];

  var setItemRef = useForkRef(overflowRef, ref);
  useEffect(function () {
    if (detectTruncation) {
      var timeout = setTimeout(function () {
        return setOpenTooltip(highlighted);
      }, highlighted ? enterDelay : leaveDelay);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, [highlighted, enterDelay, leaveDelay, detectTruncation]);

  var renderItem = function renderItem() {
    var _classnames;

    return /*#__PURE__*/React.createElement("div", _assign({
      "aria-label": typeof children === 'string' ? children : undefined
    }, restProps, {
      className: classnames(classes.root, classes["".concat(density, "Density")], (_classnames = {}, _defineProperty(_classnames, classes.highlighted, highlighted), _defineProperty(_classnames, classes.selected, selected && !checkable), _defineProperty(_classnames, classes.focusVisible, focusVisible), _defineProperty(_classnames, classes.quickSelected, quickSelected), _defineProperty(_classnames, classes.disabled, disabled), _classnames), className),
      ref: detectTruncation ? ref : setItemRef
    }), detectTruncation ? /*#__PURE__*/React.createElement(React.Fragment, null, checkable ? /*#__PURE__*/React.createElement(CheckboxBase, {
      "aria-hidden": true,
      checked: selected,
      className: classes.checkbox,
      tabIndex: -1
    }) : null, /*#__PURE__*/React.createElement("span", {
      className: classes.textWrapper,
      ref: overflowRef
    }, itemTextHighlightPattern == null ? children : /*#__PURE__*/React.createElement(Highlighter, {
      classes: {
        highlight: classes.textHighlight
      },
      matchPattern: itemTextHighlightPattern,
      text: children
    }))) : children);
  };

  return isOverflowed ? /*#__PURE__*/React.createElement(Tooltip, {
    open: openTooltip,
    placement: placement,
    title: tooltipText
  }, renderItem()) : renderItem();
});
process.env.NODE_ENV !== "production" ? ListItemBase.propTypes = {
  /**
   * If `true`, the component will have a checkbox.
   */
  checkable: PropTypes.bool,

  /**
   * The content of the item.
   */
  children: PropTypes.node,

  /**
   * The className(s) of the component.
   */
  className: PropTypes.string,

  /**
   * Useful to extend the style applied to components.
   */
  classes: PropTypes.objectOf(PropTypes.string).isRequired,

  /**
   * The density of a component affects the style of the layout.
   *
   * A high density component uses minimal sizing and spacing to convey the intended UI design.
   * Conversely, a low density component, maximizes the use of space and size to convey the UI Design.
   */
  density: PropTypes.oneOf(['touch', 'low', 'medium', 'high']),

  /**
   * If `true`, the component will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the component will have a focus ring around it.
   */
  focusVisible: PropTypes.bool,

  /**
   * If `true`, the component will have the highlighted style.
   */
  highlighted: PropTypes.bool,

  /**
   * Used for providing text highlight.
   *
   * It can be a capturing regex or a string for a straightforward string matching.
   */
  itemTextHighlightPattern: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string]),

  /**
   * If `true`, the component will have the quick selection style.
   */
  quickSelected: PropTypes.bool,

  /**
   * If `true`, the component will have the selected style.
   */
  selected: PropTypes.bool,

  /**
   * Text displayed in tooltip when item text is truncated.
   *
   * Node that it will detect item text truncation only when its children is a string.
   */
  tooltipText: PropTypes.string
} : void 0;
export default withStyles(styles, {
  name: 'ListItem'
})( /*#__PURE__*/memo(ListItemBase));